import type { AuditLogFilters } from './types';

export interface AuditActionDescription {
    /** The part up to and including the first dot, such as "bioscope.", shown muted. */
    area: string;
    /** The rest, such as "move". The whole code when it has no area. */
    name: string;
    /** A click on the code shows exactly this action. */
    filter: AuditLogFilters;
}

export function describeAuditAction(action: string): AuditActionDescription {
    const dot = action.indexOf('.');
    return {
        area: dot > 0 ? action.slice(0, dot + 1) : '',
        name: dot > 0 ? action.slice(dot + 1) : action,
        filter: { actions: [action] },
    };
}
